var map = {
	"./aerzte.png": 50807,
	"./amazon.png": 32320,
	"./autoscout24.png": 21517,
	"./booking.png": 37847,
	"./check24.png": 99476,
	"./ekomi.png": 35915,
	"./fewo.png": 93073,
	"./glassdoor.png": 63718,
	"./golocal.png": 13465,
	"./google.png": 90565,
	"./gutebanken.png": 48942,
	"./immoscout24.svg.png": 25196,
	"./indeed.png": 80127,
	"./jameda.png": 18244,
	"./jobvoting.png": 76198,
	"./kununu.png": 90116,
	"./mobile.png": 74754,
	"./omr.png": 58644,
	"./reputationplus.png": 33421,
	"./reputationplus_icon.png": 7441,
	"./reputativ_logo.png": 84622,
	"./sanego.png": 12173,
	"./shopauskunft.png": 2055,
	"./stepstone.png": 32251,
	"./tellows.png": 97820,
	"./tripadvisor.png": 8117,
	"./trivago.png": 95828,
	"./trustedshops.png": 33068,
	"./yelp.png": 49346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51827;